<project-details-default-header [project]="project"></project-details-default-header>

<div class="project-details-versions box_default box_white" >
    <header>
        <h3>ARTWORKS</h3>
        <core-helpers-navigation-three-dots-menu
            [menu]="menu"
            (action)="onMenuClick($event)"
        ></core-helpers-navigation-three-dots-menu>
    </header>
    <project-details-versions-relateds-list
        [project]="project"
        [relateds]="relateds"
    ></project-details-versions-relateds-list>
   
    <div class="loader"  [hidden]="status != STATUS_LOADING">
        <div class="dimmed">
            <div class="dimmed_title"></div>
        </div>
    </div>

    <div class="project-details-errors">
      <core-helpers-box-http-error
          *ngIf="status == STATUS_NOT_ALLOWED"
          [code]="403"
          [message]="'Not allowed.'"
      ></core-helpers-box-http-error>

      <core-helpers-box-http-error
          *ngIf="status == STATUS_NOT_FOUND"
          [code]="404"
          [message]="'Not found.'"
      ></core-helpers-box-http-error>

      <core-helpers-box-http-error
          *ngIf="status == STATUS_ERROR"
          [code]="500"
          [message]="'Error.'"
      ></core-helpers-box-http-error>
    </div>

</div>
